<template>
  <div class="left-menu add-to-itinerary-modal">
    <div class="left-menu__top">
      <p class="m-title mobile-modal-title">Add to Itinerary</p>
      <button class="btn left-menu__close" @click.stop="close">
        <TheCrossIcon />
      </button>
    </div>
    <div class="left-menu__body">
      <AddToItineraryModalBody :event="event" @added="handleAddedToItinerary" />
    </div>
  </div>
</template>

<script>
import TheCrossIcon from '@/components/icons/TheCrossIcon.vue';
import AddToItineraryModalBody from '@/components/partials/AddToItineraryModalBody.vue';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';
import { sendGaEvent } from '@/helpers/ga/gaSend';
import ItineraryItemAddedGaEvent from '@/helpers/ga/events/ItineraryItemAddedGaEvent';

export default {
  components: {
    TheCrossIcon,
    AddToItineraryModalBody,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },

  created() {
    if (window.innerWidth < 768) {
      this.$store.dispatch('disableScroll');
    }
  },

  methods: {
    close() {
      this.$emit('close');

      if (window.innerWidth < 768) {
        this.$store.dispatch('enableScroll');
      }
    },
    handleAddedToItinerary({ itineraryId, itineraryTitle }) {
      const gaEvent = new ItineraryItemAddedGaEvent()
        .addItineraryId(itineraryId)
        .addItineraryName(itineraryTitle)
        .addItemType(getContentTypeFromEntityType(this.event.__typename))
        .addItemId(this.event.id)
        .addItemName(this.event.title);

      sendGaEvent(gaEvent);
      setTimeout(this.close, 700);
    },
  },
};
</script>
